import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PlayerDetail } from "../../components";
import { IPlayer } from "../../models/IPlayer";
import { getPlayerById } from "../../api/players";
import { Loader } from "../../ui";

const PlayerDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [player, setPlayer] = useState<IPlayer>();

  const getPlayerDetail = async () => {
    try {
      const { data } = await getPlayerById(id!);
      setPlayer(data);
      document.title = `Players - ${data.firstName} ${data.lastName ?? ""}`;
    } catch (err: any) {
    } finally {
      setLoading(false);
    }
  };

  const handleBack = (count: number) => {
    navigate(-(count + 1));
  };

  useEffect(() => {
    getPlayerDetail();
  }, []);

  return (
    <div className="player-detail-page">
      {loading ? (
        <Loader />
      ) : (
        <div>
          <PlayerDetail item={player as IPlayer} onBack={handleBack} onUpdate={getPlayerDetail} />
        </div>
      )}
    </div>
  );
};

export default PlayerDetailPage;
